import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { CatalogueProvider } from "@/context/CatalogueContext";
import { RequireAuth, RequireOwner, PublicOnly } from "@/components/layout/Guards";
import AppShell from "@/components/layout/AppShell";
import SignIn from "@/pages/SignIn";
import ForgotPassword from "@/pages/ForgotPassword";
import RequestInvitation from "@/pages/RequestInvitation";
import TokenPassword from "@/pages/TokenPassword";
import Setup from "@/pages/Setup";
import Welcome from "@/pages/Welcome";
import Home from "@/pages/Home";
import Profile from "@/pages/Profile";
import { NotFound } from "@/pages/Placeholders";
import MyRuns from "@/pages/MyRuns";
import Feedback from "@/pages/Feedback";
import FeedbackAdmin from "@/pages/admin/FeedbackAdmin";
import { WhatsNew, AnnouncementsAdmin, UsageAdmin } from "@/pages/admin/Pass6Admin";
import FindAgent from "@/pages/FindAgent";
import TeamPage from "@/pages/TeamPage";
import AgentPage from "@/pages/AgentPage";
import WorkflowPage from "@/pages/WorkflowPage";
import PromptHub from "@/pages/PromptHub";
import { WebhooksAdmin } from "@/pages/admin/Pass2Admin";
import AdminLayout from "@/pages/admin/AdminLayout";
import UsersAdmin from "@/pages/admin/UsersAdmin";
import ImportAdmin from "@/pages/admin/ImportAdmin";
import CatalogueAdmin from "@/pages/admin/CatalogueAdmin";
import AuditAdmin from "@/pages/admin/AuditAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import ActivityAdmin from "@/pages/admin/ActivityAdmin";

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <CatalogueProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/signin" element={<PublicOnly><SignIn /></PublicOnly>} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/request-invitation" element={<RequestInvitation />} />
              <Route path="/set-password" element={<TokenPassword mode="invite" />} />
              <Route path="/reset-password" element={<TokenPassword mode="reset" />} />
              <Route path="/setup" element={<PublicOnly><Setup /></PublicOnly>} />
              <Route path="/welcome" element={<RequireAuth allowOnboarding><Welcome /></RequireAuth>} />
              <Route element={<RequireAuth><AppShell /></RequireAuth>}>
                <Route index element={<Home />} />
                <Route path="agents" element={<FindAgent />} />
                <Route path="agents/:empNo" element={<AgentPage />} />
                <Route path="workflows/:wid" element={<WorkflowPage />} />
                <Route path="teams/:teamId" element={<TeamPage />} />
                <Route path="prompts" element={<PromptHub />} />
                <Route path="runs" element={<MyRuns />} />
                <Route path="feedback" element={<Feedback />} />
                <Route path="whats-new" element={<WhatsNew />} />
                <Route path="profile" element={<Profile />} />
                <Route path="admin" element={<RequireOwner><AdminLayout /></RequireOwner>}>
                  <Route index element={<Navigate to="users" replace />} />
                  <Route path="users" element={<UsersAdmin />} />
                  <Route path="catalogue" element={<CatalogueAdmin />} />
                  <Route path="import" element={<ImportAdmin />} />
                  <Route path="announcements" element={<AnnouncementsAdmin />} />
                  <Route path="feedback" element={<FeedbackAdmin />} />
                  <Route path="activity" element={<ActivityAdmin />} />
                  <Route path="usage" element={<UsageAdmin />} />
                  <Route path="webhooks" element={<WebhooksAdmin />} />
                  <Route path="audit" element={<AuditAdmin />} />
                  <Route path="settings" element={<SettingsAdmin />} />
                </Route>
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" duration={3000} />
        </CatalogueProvider>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
